import useOnScreen from "../../components/UseOnScreen/UseOnScreen";
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/ChildrenAndTeenagers.css";

const ChildrenAndTeenagers = () => {
  const [aboutRef,
    isVisible] = useOnScreen({threshold: 0.5, once: true});
  const teenagersText = "Essa escuta permite diminuir a angústia diante de diagnósticos, dificuldades escolares ou crises emocionais e abre espaço para criar recursos para lidar com essas questões.";

  return (
    <div id="children-and-teenagers" className="" ref={aboutRef}>
      <div className="teenagers-container">
        <div className="teenagers-text">
          <h1>Crianças e<br></br> adolescentes</h1>
          <span>
            No trabalho com a infância e a adolescência também ofereço  espaço de escuta permitindo que possam
             reelaborar experiências de perda, angústia, separação, ajudando o sujeito  a atravessar 
             este momento e encontrar 
            seu próprio jeito de se posicionar.
             <br></br>
             <br></br>
            A orientação e acolhimento aos pais é uma extensão  deste trabalho analítico e contribui para
             a compreensão do momento dos filhos.
          </span>
        </div>
        <div className="teenagers-second-text">
            {isVisible ? (
                <>
                    <TypingEffect
                        text={teenagersText}
                        speed={70}    
                        className="teenagers-phrase"
                    />
                </>
            ) : (
                <div className="placeholder-text">
                    <span className="teenagers-phrase">{teenagersText}</span>
                </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default ChildrenAndTeenagers;
